<template>
	<modal name="create-playlist" @opened="opened" :width="270" height="auto" style="z-index: 10000000">
		<div id="create-playlist-modal">
			<h1>{{ $t('playlist.create') }}</h1>
			<form @submit.prevent="onSubmit">
				<input ref="createPlaylistEmailInput" type="text" name="create-playlist-title-input" :placeholder="$t('playlist.title')" v-model="title" autocomplete="off">
				<button type="submit" class="create-playlist-submit">{{ $t('playlist.create') }}</button>
			</form>
		</div>
	</modal>
</template>

<script>
	import Vue from "vue";
	import { PlaylistService } from "@/services/PlaylistService";

	export default {
		data() {
			return {
				title: null,
			};
		},
		methods: {
			opened() {
				Vue.nextTick(() => {
					this.$refs.createPlaylistEmailInput.focus();
				});
			},
			onSubmit() {
				PlaylistService.createPlaylist(this.title);
				this.$notify({
					type: "success",
					text: this.$t("playlist.created"),
				});
				this.$modal.hide("create-playlist");
				this.title = null;
			}
		}
	}
</script>

<style lang="scss" scoped>
	#create-playlist-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-size: 1.1em;

		h1 {
			margin: 0;
			padding: 20px 20px;
			font-size: 1.4em;
			font-weight: 100;
		}

		.or {
			text-align: center;
			margin-bottom: 20px;
		}

		input {
			width: 100%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			background-color: rgba(255, 255, 255, 0.21);
			font-weight: 300;
			color: rgba(255, 255, 255, 0.8);
			border: 0;
			margin-bottom: 1px;

			&::placeholder {
				color: rgba(255, 255, 255, 0.49);
			}

			&:focus {
				outline: none;
			}
		}

		button.create-playlist-submit {
			width: 100%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			background: rgb(233,196,106); /* Old browsers */
			background: -moz-linear-gradient(left, rgba(233,196,106,1) 1%, rgba(244,162,97,1) 100%); /* FF3.6-15 */
			background: -webkit-linear-gradient(left, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* Chrome10-25,Safari5.1-6 */
			background: linear-gradient(to right, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
			filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e9c46a', endColorstr='#f4a261',GradientType=1 ); /* IE6-9 */
			font-weight: 300;
			color: rgba(255, 255, 255, 0.8);
			border: 0;
			margin: 20px 0 0 0;
			cursor: pointer;

			&:hover {
				opacity: 0.9;
			}
		}

	}
</style>
